import { validate as isUuid } from 'uuid'

/** Query param for deep-linking to a saved table view on staff list pages. */
export const VIEW_UUID_QUERY_PARAM = 'viewUuid'

export const parseViewUuidFromSearch = (search: string): string | null => {
  const raw = new URLSearchParams(search).get(VIEW_UUID_QUERY_PARAM)?.trim()
  if (!raw || !isUuid(raw)) {
    return null
  }
  return raw
}
